import React from 'react';
import MessageBox from '../../../components/MessageBox';

const MessageHeading = ({ text, className }) => {
    return (
        <h5 className={`${className} theme-text-color mb-3`}><MessageBox text={text} /></h5>
    )
}

export default MessageHeading